import Plyr from "plyr";
import { Popup } from "./popup";
const videos = {
  videosClick: document.querySelectorAll(
    ".jsPlayerOnClick"
  ) as NodeListOf<HTMLElement>,
  playersClick: [] as Array<Plyr>,

  init() {
    if (this.videosClick.length) {
      this.loadOnPopup();
      this.onClick();
      this.setPopups();
    }
  },
  loadOnPopup() {
    window.addEventListener("popupOpen", () => {
      this.videosInit();
    });
  },
  setPopups() {
    const videoPopup = new Popup("#videoPopup", "#videoPopupOpen", ".jsClose");
    videoPopup.init();
  },
  videosInit() {
    if (!this.playersClick.length) {
      this.playersClick = Array.from(this.videosClick).map((p) => new Plyr(p));
    }
  },
  onClick() {
    this.playersClick.forEach((item, index) => {
      const buttons = item.elements.buttons.play as HTMLButtonElement[];
      buttons?.forEach((item) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
        });
      });
      item.on("play", () => {
        this.playersClick.forEach((el, i) => {
          if (index !== i) {
            el.pause();
          }
        });
      });
    });
  },
};

export default videos;
